import { gql } from '__generated__';

export default gql(`
  mutation DuplicateEvent($input: DuplicateEventInput!) {
    duplicateEvent(input: $input) {
      id
    }
  }
`);
